import { render, staticRenderFns } from "./ContentTab2.vue?vue&type=template&id=6eefcb4a&scoped=true"
import script from "./ContentTab2.vue?vue&type=script&lang=ts"
export * from "./ContentTab2.vue?vue&type=script&lang=ts"
import style0 from "./ContentTab2.vue?vue&type=style&index=0&id=6eefcb4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eefcb4a",
  null
  
)

export default component.exports